var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "voucher__col" }, [
      _c("h2", { staticClass: "voucher__col-title" }, [
        _vm._v("\n      " + _vm._s(_vm.$t("vouchers.chooseTitle")) + "\n    "),
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("  " + _vm._s(_vm.$t("vouchers.instrText")))]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "voucher-list" },
        _vm._l(_vm.vouchers, function (voucher) {
          return _c("div", { key: voucher.id, staticClass: "row" }, [
            _c("div", { staticClass: "voucher-list__item" }, [
              _c("h3", [_vm._v(_vm._s(voucher.title))]),
              _vm._v(" "),
              _c("div", { staticClass: "voucher__info" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(voucher.description) +
                    "\n            "
                ),
                _c("div", [
                  _vm._v(
                    "CHF " +
                      _vm._s(voucher.price) +
                      " / " +
                      _vm._s(_vm.$t("vouchers.pcs"))
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "plus-minus" }, [
              _c(
                "button",
                {
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.onVoucherSub(voucher)
                    },
                  },
                },
                [_c("SVGMinus")],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "plus-minus__counter" }, [
                _vm._v(
                  "\n            " + _vm._s(voucher.quantity) + "\n          "
                ),
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.onVoucherAdd(voucher)
                    },
                  },
                },
                [_c("SVGPlus")],
                1
              ),
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.number",
                  value: voucher.quantity,
                  expression: "voucher.quantity",
                  modifiers: { number: true },
                },
              ],
              attrs: { name: `voucher[${voucher.id}]`, type: "hidden" },
              domProps: { value: voucher.quantity },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(voucher, "quantity", _vm._n($event.target.value))
                },
                blur: function ($event) {
                  return _vm.$forceUpdate()
                },
              },
            }),
          ])
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }